import * as React from 'react';
import { ApiToUse, SimpleFormComponentProps, SerializeType } from 'app/infrastructure/simple-form/types';
import { FIELD_TYPE } from 'app/infrastructure/simple-form/field-types';
import { AdministrationUserEditProps } from './types';
import { ids } from 'app/area/administration/constants';
import { userOptions } from '../endpoints';
import { sfNames } from 'app/area/administration/edit/sf-names';
import { AdminPaperSubPanel } from 'app/area/administration/edit/components';
import { UserGroup } from 'app/area/administration/edit/user/user-group';
import style from 'app/area/administration/edit/edit.scss';
import { clearValidationFactory } from 'app/area/administration/shared/helpers';
export interface UserTypeGroupProps extends AdministrationUserEditProps {
  formComponent: React.ComponentType<SimpleFormComponentProps>;
}

const getMainUserGroup = (formValues) => formValues &&
  formValues[sfNames.mainUserGroup] &&
  formValues[sfNames.mainUserGroup].value || undefined;

export class UserTypeGroup extends React.PureComponent<UserTypeGroupProps> {

  public componentDidUpdate(prevProps: AdministrationUserEditProps) {

    // Current user group is dependent on Main user group. Therefore, when 
    // Main user group is being changed, current user group must be cleared 
    const prevMainUserGroup = getMainUserGroup(prevProps.formValues);
    const nextMainUserGroup = getMainUserGroup(this.props.formValues);
    if (prevMainUserGroup && prevMainUserGroup !== nextMainUserGroup) {
      this.props.clearValueInStore(sfNames.currentUserGroup);
    }
  }

  public render() {

    const { formComponent: SimpleForm, data, editMode, formValues, translation, clearValidation } = this.props;

    const mainUserGroup = getMainUserGroup(formValues);

    const userGroupProps = {
      editMode,
      translation,
      clearValidation,
      formComponent: SimpleForm
    };
    
    return <AdminPaperSubPanel title={translation.user_type_and_group}>
      <div className={style.section}>
        <div className="row expanders-in-equal-cols">
          <div id={ids.users.user_type} className="col-lg-4 col-sm-12">
            <SimpleForm
              name={sfNames.userType}
              type={FIELD_TYPE.SELECT_SINGLE_HIERARCHY}
              optionsEndpoint={userOptions.usertype}
              label={{ text: translation.user_type, required: editMode }}
              apiToUse={ApiToUse.ADMINAPI}
              placeholder={translation.search}
              translation={translation}
              initialValue={data && data.userType}
              serialize={{ type: SerializeType.V_VALUE }}
              readOnly={!editMode}
              clearServerValidation={clearValidationFactory(sfNames.userType, clearValidation)}
            />
          </div>

          <div id={ids.users.main_user_group} className="col-lg-4 col-sm-12">
            <UserGroup
              fieldName={sfNames.mainUserGroup}
              readOnly={!editMode}
              labelText={translation.main_user_group}
              initialValue={data && data.mainUserGroup}
              optionsEndpoint={userOptions.mainUsergroup}
              {...userGroupProps}
            />
          </div>

          <div id={ids.users.current_user_group} className="col-lg-4 col-sm-12">
            <UserGroup
              fieldName={sfNames.currentUserGroup}
              readOnly={!mainUserGroup || !editMode}
              labelText={translation.current_user_group}
              initialValue={data && data.currentUserGroup}
              optionsEndpoint={userOptions.currentUsergroup(mainUserGroup)}
              optionsParams={mainUserGroup && { mainUserGroup }}
              {...userGroupProps}
            />
          </div>
        </div>
      </div>
    </AdminPaperSubPanel>;
  }
}
